import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { GeneralInfoDTO } from '@booking/angular-booking-user-data-service';

@Component({
  selector: 'app-view-general-info',
  templateUrl: './view-general-info.component.html',
  styleUrls: ['./view-general-info.component.scss'],
})
export class ViewGeneralInfoComponent {
  @Input() data: GeneralInfoDTO;
  @Input() managerSystem: any;
  @Input() isCM: boolean;

  generalInfoForm: FormGroup = new FormGroup({
    dummy: new FormControl(''),
  });
}
